import notfound from '../../../Assets/images/il-empty.svg';
import React, { useEffect, useRef, useState } from 'react';
import { usePagination, useSortBy, useTable, useGlobalFilter, useFilters } from 'react-table';
import useLogin from '../../Autenticacion/Hooks/useLogin';
import Button from "../../../Components/Button/Button";
import Exports from '../../../Components/Exports/Exports';
import {EnumTablaPaginacion} from '../../../Utils/Enumeradores/ComunEnum'
import BitacoraIrdmField from './BitacoraIrdmField';
import PaginationComponent from '../../../Components/PaginationTableServer/PaginationTableServer';
import { Form, Formik } from 'formik';
import validations from '../../../Utils/Validations/Validations';
import { useRegistroTDR } from '../../../Hooks/useRegistroTDR';

const BitacoraBimTable = ({ columns, data, fetchData, pageCount: controlledPageCount, currentpage, pageSize: controlledPageSize, sortBy: controlledSortBy, setPagination, handlerModal, valoresBusqueda, setValoresBusqueda }) => {
	const {
		getTableProps
		, getTableBodyProps
		, headerGroups
		, prepareRow
		, page
		, pageCount
		, gotoPage
		, setSortBy
		, state: { pageIndex, pageSize, sortBy }
	} = useTable(
		{
			columns
			, data
			, initialState: { pageIndex: currentpage, pageSize: controlledPageSize, sortBy: controlledSortBy }
			, manualPagination: true
			, pageCount: controlledPageCount
			, autoResetPage: false
			, autoResetSortBy: false
			, manualSortBy: true
		},
		useSortBy,
		usePagination
	);

	const { usuario } = useLogin();
	const { crearRegistroTDR } = useRegistroTDR();
	const formikRef = useRef();
	const [initialValues, setInitialValues] = useState({
		idBim: '',
		idSice: ''
	});
	const [idbimAplicado, setIdbimAplicado] = useState("");
	const [idSiceAplicado, setIdSiceAplicado] = useState("");
	const [valoresFormularioEnvio, setValoresFormularioEnvio] = useState({
		paginacion: {
			numeroPagina: pageIndex
			, cantidadRegistros: pageSize
			, orderByAscending: true
			, ordenadoPor: "idBim"
		},
		datosBusqueda: {
			idUsuario: usuario.id
			, idBim: ''
			, idSice: 0
			, exportacion: false
		}
	});
	useEffect(() => {
		fetchData({ formulario: valoresFormularioEnvio, pageIndex, sortBy });
		/* GUARDAMOS EL SORTBY EN EL USESTATE DE PAGINATION QUE SE ENCUENTRA EN ALARMASPAGE PARA QUE NO SE PIERDA EL ORDENAMIENTO */
		setPagination(values => ({
			...values
			, sortBy: sortBy
		}));
	}, [pageIndex, sortBy])

	const descargar = () => {
		fetchData({ formulario: valoresFormularioEnvio, pageIndex: pageIndex, sortBy, exportacion: true });
	};

	function BuscarActividadBim(values) {
		const startTime = new Date();
		setIdbimAplicado((values.idBim || "").trim());
		setIdSiceAplicado((values.idSice || "").trim());
		let formEnvio = valoresFormularioEnvio;
		/* Se setean valores del paginado para la primera busqueda (resetea la tabla) */
		formEnvio.paginacion.numeroPagina = 0;
		formEnvio.paginacion.orderByAscending = false;
		formEnvio.paginacion.ordenadoPor = "fechaCreacion";
		/* Se setean los valores de los campos que ingresa el usuario */
		formEnvio.datosBusqueda.idBim = values.idBim;
		formEnvio.datosBusqueda.idSice = values.idSice ? Number(values.idSice) : 0;
		setValoresBusqueda({ idBim: values.idBim, idSice: values.idSice });
		const fetchData = async () => {
			await Promise.all([
				setValoresFormularioEnvio(formEnvio)
			]);
			const endTime = new Date();
			const tdrId = 29;
			crearRegistroTDR(startTime, endTime, usuario, tdrId);
		};

		fetchData();
		setPagination({
			pageIndex: formEnvio.paginacion.numeroPagina,
			pageSize: formEnvio.paginacion.cantidadRegistros,
			sortBy: []
		});
		setSortBy([]);
		gotoPage(0);
	};

	const mostrarModal = (e, row) => {
		e.preventDefault();
		handlerModal(row);
	}

	function limpiarIdbimAplicado() {
		formikRef.current?.setFieldValue('idBim', '');
		setIdbimAplicado("");
		BuscarActividadBim({ idBim: '', idSice: idSiceAplicado });
	}

	function limpiarIdSiceAplicado() {
		formikRef.current?.setFieldValue('idSice', '');
		setIdSiceAplicado("");
		BuscarActividadBim({ idBim: idbimAplicado, idSice: '' });
	}

	return (
		<div>
			<div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center mb-5 gap-3">
								<Formik
									innerRef={formikRef}
									enableReinitialize
									initialValues={initialValues}
									validate={validations}
									onSubmit={(values) => {
										BuscarActividadBim(values);
									}}
								>
									{({ values, setFieldValue, setFieldTouched, }) => (
										<Form className="form mb-0">
											<div className="tools order-1 order-lg-0 align-items-start">
												<div className='bitacora-irdm-filter'>
													<BitacoraIrdmField
														name="idBim"
														label="ID BIM"
														type="text"
														placeholder="Ingresar"
														autoComplete="off"
														disabled={!!values.idSice}
													/>
												</div>
												<div className='bitacora-irdm-filter'>
													<BitacoraIrdmField
														name="idSice"
														label="ID SICE"
														type="text"
														placeholder="Ingresar"
														autoComplete="off"
														disabled={!!values.idBim}
														onInput={(e) => {
															e.target.value = e.target.value.replace(/\D/g, '');
														}}
													/>
												</div>
												<Button type="submit" design="btn-primary">Buscar</Button>
											</div>
										</Form>
									)}
								</Formik>
								{
								data.length > 0 &&
									<div className="exports order-0 order-lg-1">
									<Exports descargar={() => descargar()} />
									</div>
								}
							</div>
			{(idbimAplicado || idSiceAplicado) && (
				<div className="d-flex gap-2" style={{ marginTop: "16px", marginBottom: "16px" }}>
					{idbimAplicado && (
						<span className="datamart-applied-filter">
							<span className="datamart-applied-filter__label">ID BIM: {idbimAplicado}</span>
							<button type="button" className="datamart-applied-filter__close" onClick={limpiarIdbimAplicado} aria-label="Limpiar filtro ID BIM">
								<i className="ico-close"></i>
							</button>
						</span>
					)}
					{idSiceAplicado && (
						<span className="datamart-applied-filter">
							<span className="datamart-applied-filter__label">ID SICE: {idSiceAplicado}</span>
							<button type="button" className="datamart-applied-filter__close" onClick={limpiarIdSiceAplicado} aria-label="Limpiar filtro ID SICE">
								<i className="ico-close"></i>
							</button>
						</span>
					)}
				</div>
			)}
			<div className="table-responsive brd-top">
				<table className="table" {...getTableProps()}>
					<thead>
						{headerGroups.map((headerGroup) => {
							const { key: hgKey, ...hgProps } = headerGroup.getHeaderGroupProps();
							return (
							<tr key={hgKey} {...hgProps}>
								{headerGroup.headers.map((column) => {
									const { key: thKey, ...thProps } = column.getHeaderProps(column.getSortByToggleProps(), { className: column.className });
									const { key: thKeyNoSort, ...thPropsNoSort } = column.getHeaderProps();
									return (
									data.length > 0 ?
									<th key={thKey} {...thProps}>
										<span className="d-flex align-items-center gap-1">
											{column.render('Header')}
											<>
												{column.isSorted ?
													(column.isSortedDesc  && data.length > 0 ?
														<i className="ico-chevron-down"></i>
														:
														<i className="ico-chevron-up"></i>
													) :
													<>
														<i className="ico-sort fs-7"></i>
													</>
												}
											</>
										</span>
									</th>
									:
									<th key={thKeyNoSort} {...thPropsNoSort}
									>
										<span className="d-flex align-items-center gap-1">
											{column.render('Header')}
										</span>
									</th>
									);
								})}
								<th className="text-center">Detalle</th>
							</tr>
							);
						})}
					</thead>
					<tbody {...getTableBodyProps()}>
						{
							page.length > 0 && page.map( (row) => {
								prepareRow(row)
								const { key: trKey, ...trProps } = row.getRowProps();
								return (
									<tr key={trKey} {...trProps}>
										{row.cells.map((cell) => {
											const { key: tdKey, ...tdProps } = cell.getCellProps({
												className: cell.column.className
											});
											return <td key={tdKey} {...tdProps}>
												{cell.render('Cell')}
											</td>
										})}
										<td className="text-center">
											<button className="link text-pewter-blue fs-4" onClick={(e) => mostrarModal(e, row.original)}>
												<i className="ico-search"></i>
											</button>
										</td>
									</tr>
									)
							}) || <tr><td colSpan={headerGroups[0].headers.length + 1}>
							<div className="d-flex justify-content-center align-items-center flex-column gap-2 py-5">
								<img className="mb-3" src={notfound} alt=""/>
								<p className='mb-0 text-primary'>No se encuentran resultados de tu búsqueda.</p>
							</div>
						</td></tr>
						}
					</tbody>
				</table>
			</div>
			{
				data.length > 0 &&
				<PaginationComponent
					pagesCountServer={pageCount}
					currentPage={pageIndex}
					setCurrentPage={gotoPage}
					alwaysShown={false}
					setPagination={setPagination}
				/>
			}
		</div>
	)
}

export default BitacoraBimTable;

